import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import SummaryApi from "../common/index";
 // Add this import
const FollowupModal = ({ isOpen, onClose, student, onSuccess }) => {
  const [nextFollowUpDate, setNextFollowUpDate] = useState(null);
  const [leadDescription, setLeadDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [previousFollowups, setPreviousFollowups] = useState([]);
  const [fetchingPrevious, setFetchingPrevious] = useState(false);

  useEffect(() => {
    if (!isOpen || !student?.student_id) {
      setPreviousFollowups([]);
      return;
    }










    const fetchPrevious = async () => {
      setFetchingPrevious(true);
      try {
        const encodedEmpId = sessionStorage.getItem("H7Z4L9VD2XK5JW8QRYT6");
        if (!encodedEmpId) throw new Error("Employee ID not found");

        const employee_id = atob(encodedEmpId);

        const response = await fetch(SummaryApi.followupDatesByEmpIdStudId.url, {
          method: SummaryApi.followupDatesByEmpIdStudId.method,
          headers: {
            Authorization: "Bearer sandeep_university_916",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            employee_id,
            student_id: student.student_id,
          }),
        });

        const result = await response.json();

        if (result.status && Array.isArray(result.data)) {
          setPreviousFollowups(result.data);
        } else {
          setPreviousFollowups([]);
          toast.info(result.message || "No previous follow-ups found");
        }
      } catch (err) {
        console.error("Fetch previous followups failed:", err);
        setPreviousFollowups([]);
      } finally {
        setFetchingPrevious(false);
      }
    };

    fetchPrevious();

    return () => {
      setPreviousFollowups([]);
      setFetchingPrevious(false);
    };
  }, [isOpen, student?.student_id]);
useEffect(() => {
  if (!isOpen) return;

  // Remember the original overflow value
  const originalStyle = window.getComputedStyle(document.body).overflow;

  // Disable scrolling on body
  document.body.style.overflow = 'hidden';

  // Restore when modal closes / effect cleans up
  return () => {
    document.body.style.overflow = originalStyle;
  };
}, [isOpen]);
  if (!student) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!nextFollowUpDate) {
      toast.error("Please select next follow-up date & time");
      return;
    }

    setLoading(true);

    try {
      const encodedEmpId = sessionStorage.getItem("H7Z4L9VD2XK5JW8QRYT6");
      if (!encodedEmpId) throw new Error("Employee ID not found");

      const employee_id = atob(encodedEmpId);

      // Send local IST time string instead of UTC ISO
      const selectedDateTimeLocal = nextFollowUpDate.toLocaleString('en-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }).replace(',', '');  // "2026-02-04 12:30:00"

      const payload = {
        student_id: student.student_id,
        employee_id,
        student_name: student.student_name || "",
        mobile_number1: student.mobile_number1 || "",
        enrollment_code: student.enrollment_code || "",
        district: student.district || "",
        city: student.city || "",
        clg_name: student.clg_name || "",
        is_interested: student.is_interested || "",
        next_followup_date_time: selectedDateTimeLocal,  // ← now correct local time
        lead_description: leadDescription.trim(),
        is_closed: 0,
        is_active: 1,
        created_date: new Date().toISOString(),
      };

      const response = await fetch(SummaryApi.CreateFollowupByEmployeeId.url, {
        method: SummaryApi.CreateFollowupByEmployeeId.method,
        headers: {
          Authorization: "Bearer sandeep_university_916",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (result.status) {
        toast.success("Follow-up added successfully!");
        setNextFollowUpDate(null);
        setLeadDescription("");
        onSuccess();
      } else {
        toast.error(result.message || "Failed to add follow-up");
      }
    } catch (err) {
      console.error("Follow-up creation failed:", err);
      toast.error(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const formatDateTime = (dateStr) => {
    if (!dateStr || dateStr === "0000-00-00 00:00:00") return "N/A";
    return new Date(dateStr).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const validFollowups = previousFollowups.filter(fu =>
    fu.next_followup_date_time &&
    fu.next_followup_date_time !== "0000-00-00 00:00:00" &&
    fu.next_followup_date_time !== "0000-00-00 00:00:00.000000"
  );

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="mx-auto my-8 max-w-2xl bg-white rounded-lg shadow-2xl outline-none max-h-[85vh] overflow-hidden flex flex-col"
      overlayClassName="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50"
    >
      <div className="p-5 flex-1 overflow-y-auto">
<div className="flex justify-between items-center mb-4 border-b pb-2">
  <h2 className="text-xl font-bold text-gray-800 flex items-center gap-2">
    Add Follow-up for {student.student_name || "Student"}

  </h2>
  <button
    onClick={onClose}
    className="text-gray-600 hover:text-red-600 text-2xl leading-none"
  >
    ×
  </button>
</div>

        {/* Student Info */}
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-5 text-sm bg-gray-50 p-3 rounded-lg">
          <div>
            <label className="font-semibold block text-gray-700">Mobile:</label>
            <p>{student.mobile_number1 || "N/A"}</p>
          </div>
          <div>
            <label className="font-semibold block text-gray-700">College:</label>
            <p>{student.clg_name || "N/A"}</p>
          </div>
          <div>
            <label className="font-semibold block text-gray-700">District:</label>
            <p>{student.district || "N/A"}</p>
          </div>
          <div>
            <label className="font-semibold block text-gray-700">City:</label>
            <p>{student.city || "N/A"}</p>
          </div>
          <div>
            <label className="font-semibold block text-gray-700">Current Status:</label>
            <p>{student.is_interested || "N/A"}</p>
          </div>
          <div>
            <label className="font-semibold block text-gray-700">Last Follow-up:</label>
            <p>{student.follow_up_date ? formatDateTime(student.follow_up_date) : "N/A"}</p>
                {previousFollowups.length > 0 && (
      <span className="inline-flex items-center px-2 py-0.5 text-xs font-medium text-purple-800 bg-purple-50 rounded-full">
        {previousFollowups.length} follow-up{previousFollowups.length !== 1 ? 's' : ''}
      </span>
    )}
          </div>
        </div>
        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block font-medium mb-1.5 text-gray-700 text-sm">
              Next Follow-up Date & Time <span className="text-red-600">*</span>
            </label>
            <DatePicker
              selected={nextFollowUpDate}
              onChange={setNextFollowUpDate}
              showTimeSelect
              timeFormat="hh:mm aa"
              timeIntervals={1}
              dateFormat="dd/MM/yyyy hh:mm aa"
              minDate={new Date()}
              className="w-full p-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 text-sm"
              placeholderText="Select date and time"
            />
          </div>

          <div className="mb-5">
            <label className="block font-medium mb-1.5 text-gray-700 text-sm">
              Lead Description / Notes
            </label>
            <textarea
              value={leadDescription}
              onChange={(e) => setLeadDescription(e.target.value)}
              rows={3}
              className="w-full p-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 text-sm"
              placeholder="Enter discussion points, outcome, next action..."
            />
          </div>

          <div className="flex justify-end gap-3">
            <button
              type="submit"
              disabled={loading}
              className="px-5 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50 transition font-medium text-sm"
            >
              {loading ? "Saving..." : "Add Follow-up"}
            </button>
          </div>
          
        </form>
        {/* Previous Follow-ups */}
        <div className="mb-5">
          <h3 className="font-semibold text-base mb-2 text-gray-800">
            Next Follow-ups
          </h3>

          {fetchingPrevious ? (
            <p className="text-gray-500 italic text-sm">Loading previous follow-ups...</p>
          ) : validFollowups.length === 0 ? (
            <p className="text-gray-500 italic bg-gray-50 p-2.5 rounded text-sm">
              No previous follow-ups with valid next follow-up date.
            </p>
          ) : (
            <div className="max-h-52 overflow-y-auto border border-gray-200 rounded-lg bg-white shadow-inner">
              {validFollowups.map((fu, index) => (
                <div
                  key={fu.student_followups_id || index}
                  className="p-2.5 border-b last:border-b-0 hover:bg-gray-50 transition"
                >
                  <div className="flex justify-between items-start gap-3">
                    <div className="flex-1">
                      <p className="font-medium text-purple-700 mb-0.5 text-sm">
                        Next Followup Date : {formatDateTime(fu.next_followup_date_time)}
                      </p>
                      <p className="text-sm text-gray-700 whitespace-pre-wrap">
                        Next Followup : {fu.lead_description || "---"}
                      </p>
                    </div>
                    {/* <span className="text-xs text-gray-500 whitespace-nowrap">
                      {fu.created_date ? new Date(fu.created_date).toLocaleDateString() : ""}
                    </span> */}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>


      </div>
    </Modal>
  );
};

export default FollowupModal;